import React__default from 'react';
import { cssTransition, ToastContainer as ToastContainer$1 } from 'react-toastify';
import styled from 'styled-components';

const ToastTransition = cssTransition({
  enter: 'toast-enter',
  exit: 'toast-exit',
  appendPosition: true
});
const StyledContainer = styled(ToastContainer$1).withConfig({
  displayName: "ToastContainer__StyledContainer",
  componentId: "sc-1ik53lz-0"
})(["&&&.Toastify__toast-container{background:transparent;padding:0;margin:0;box-shadow:none;width:auto;z-index:9999;transform:translate3d(0,0,9999px);position:fixed;box-sizing:border-box;}.Toastify__toast,.Toastify__toast-body{background:transparent;padding:0;margin:0;box-shadow:none;cursor:inherit;}&.Toastify__toast-container--top-left{top:0;left:0;}&.Toastify__toast-container--top-center{top:0;left:50%;transform:translateX(-50%);}&.Toastify__toast-container--top-right{top:0;right:0;}&.Toastify__toast-container--bottom-left{bottom:0;left:0;}&.Toastify__toast-container--bottom-center{bottom:0;left:50%;transform:translateX(-50%);}&.Toastify__toast-container--bottom-right{bottom:0;right:0;}.Toastify__toast{position:relative;min-height:64px;box-sizing:border-box;display:flex;justify-content:space-between;max-height:800px;overflow:hidden;font-family:sans-serif;direction:ltr;}.Toastify__toast--rtl{direction:rtl;}@keyframes Toastify__trackProgress{0%{transform:scaleX(1);}100%{transform:scaleX(0);}}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards;}.Toastify__progress-bar--controlled{transition:transform 0.2s;}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;}@keyframes toast-enter-bottom{0%{transform:translate3d(0,100%,0);opacity:0;}100%{transform:translate3d(0,0,0);opacity:1;}}.toast-enter,.toast-enter--bottom-left,.toast-enter--bottom-center,.toast-enter--bottom-right{animation:toast-enter-bottom 0.25s linear both;}@keyframes toast-enter-top{0%{transform:translate3d(0,-100%,0);opacity:0;}100%{transform:translate3d(0,0,0);opacity:1;}}.toast-enter,.toast-enter--top-left,.toast-enter--top-center,.toast-enter--top-right{animation:toast-enter-top 0.25s linear both;}@keyframes toast-exit{0%{opacity:1;}100%{opacity:0;transform:scale(0.9);}}.toast-exit,.toast-exit--top-left,.toast-exit--top-center,.toast-exit--top-right,.toast-exit--bottom-left,.toast-exit--bottom-center,.toast-exit--bottom-right{animation:toast-exit 0.25s linear both;}"]);
/**
 * A container to render your `Toast` components
 *
 * Remember to render the `ToastContainer` once in your application tree. If you can't figure out where to put it,
 * rendering it in the application root would be the best bet.
 *
 */
const ToastContainer = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledContainer, {
  autoClose: false,
  closeButton: false,
  closeOnClick: false,
  containerId: "ToastContainerTop",
  draggable: false,
  enableMultiContainer: true,
  hideProgressBar: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  transition: ToastTransition
}), /*#__PURE__*/React__default.createElement(StyledContainer, {
  autoClose: false,
  closeButton: false,
  closeOnClick: false,
  containerId: "ToastContainerBottom",
  draggable: false,
  enableMultiContainer: true,
  hideProgressBar: true,
  newestOnTop: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  transition: ToastTransition
}));

export { ToastContainer };
